import { IAction } from '@r1-frontend/shared/types/Redux';

import { ECitySelect } from './index';

export type TCloseCitySelect = IAction<ECitySelect.CLOSE_CITYSELECT, null>

const closeCitySelect = (): TCloseCitySelect => ({
    type: ECitySelect.CLOSE_CITYSELECT,
    payload: null,
});

export default closeCitySelect;
